function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cleanProps from 'clean-react-props';
import nanoid from 'nanoid';

var Canvas = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Canvas, _Component);

  function Canvas(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      instanceKey: nanoid()
    };
    return _this;
  }

  var _proto = Canvas.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.draw(this.props);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.draw(this.props);
  };

  _proto.draw = function draw(props) {
    if (!this.canvas) {
      return;
    }

    props.draw(this.canvas);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        canvasRef = _this$props.canvasRef,
        width = _this$props.width,
        height = _this$props.height,
        pixelRatioAware = _this$props.pixelRatioAware,
        style = _this$props.style;
    var instanceKey = this.state.instanceKey;
    var pixelRatio = pixelRatioAware ? window.devicePixelRatio || 1 : 1;
    var ref = canvasRef ? canvasRef : function (element) {
      _this2.canvas = element;
    };
    var styleProp = Object.assign({}, style, {
      width: width,
      height: height
    });
    return React.createElement("canvas", _extends({}, cleanProps(this.props, ['width', 'height']), {
      key: instanceKey,
      ref: ref,
      width: width * pixelRatio,
      height: height * pixelRatio,
      style: styleProp
    }));
  };

  return Canvas;
}(Component);

Canvas.propTypes = {
  canvasRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.elementType
  })]),
  draw: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  pixelRatioAware: PropTypes.bool
};
Canvas.defaultProps = {
  draw: function draw() {},
  width: 30,
  height: 30,
  pixelRatioAware: true
};
export default Canvas;